import CategoryIcon from '@material-ui/icons/Category';
import CategoryList from './ArticleCategoryList';

export default {
  list: CategoryList,

  icon: CategoryIcon,
}